/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizercoveradd2Inputs */

const en_organizercoveradd2 = /** @type {(inputs: Organizercoveradd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a cover`)
};

const de_organizercoveradd2 = /** @type {(inputs: Organizercoveradd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a cover" |
*
* @param {Organizercoveradd2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizercoveradd2 = /** @type {((inputs?: Organizercoveradd2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizercoveradd2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizercoveradd2(inputs)
	return de_organizercoveradd2(inputs)
});
export { organizercoveradd2 as "organizerCoverAdd" }